import { Box, Flex, useBreakpointValue, Text, Button } from "@chakra-ui/react";
import { Constants } from "../constants";
import Header from "./Header";
import LeftNavigation from "./LeftNavigation";
import { BookOpen, CalenderTick, SchoolOutline } from "../../../assets/icons/components";
import { ContestOutline } from "../../../assets/icons/components";
import { Badge, ModalTemplate } from "../general";
import BottomTabNavbar from "./BottomTabNavbar";
import React, { useContext } from "react";
import ReferralCodeModalContent from "./ReferralCodeModalContent";
import { axiosErrorHandler } from "../../../api/utils/error";
import { updateReferralCode } from "../../../api/utils/api";
import { AppContext, ApplicationActionType } from "../../../context/ApplicationContext";

import Tour from "reactour";
import { useLocation } from "react-router-dom";
import { sendTrackingEvent } from "../utils/gtm";


interface Props {
  children: JSX.Element | JSX.Element[];
}
const Layout = ({ children }: Props) => {
  const state = useContext(AppContext)[0];

  const [isReferralModalOpen, setIsReferralModalOpen] = React.useState<undefined | boolean>();
  const [referralErrorMessage, setReferralErrorMessage] = React.useState<string | null>(null);
  const topLabelsList: {
    key: number;
    title: string;
    type: "primary" | "secondary" | "tab" | "hamburger-label";
    path: string;
    badgeComponent?: React.ReactElement;
    iconForPrimary?: React.ReactElement;
    iconForTab?: React.ReactElement;
  }[] = [
    {
      key: 1,
      title: "Courses",
      type: "primary",
      iconForPrimary: <SchoolOutline />,
      path: "/",
    },
    {
      key: 2,
      title: "Contests",
      type: "primary",
      iconForPrimary: <ContestOutline />,
      path: "/contests",
    },
    {
      key: 3,
      title: "Events & Contests",
      type: "primary",
      iconForPrimary: <CalenderTick />,

      path: "/events",
    },
    {
      key: 4,
      title: "Self learning (Free)",
      type: "primary",
      iconForPrimary: <BookOpen />,
      path: "/self-learning",
    },
  ];
  const bottomLabelsList: {
    key: number;
    title: string;
    type: "primary" | "secondary" | "tab" | "hamburger-label";
    path: string;
    badgeComponent?: React.ReactElement;
    iconForPrimary?: React.ReactElement;
    iconForTab?: React.ReactElement;
    link?: string;
    isExternal?: boolean;
  }[] = [
    {
      key: 1,
      title: "Referral Program",
      type: "secondary",

      path: "/referral-program",
      badgeComponent: <Badge variant="red" label="New" />,
    },
    {
      key: 2,
      title: "Documents",
      type: "secondary",
      path: "/batch-docs",
    },
    {
      key: 3,
      title: "PAP",
      type: "secondary",

      path: "/isa",
      isExternal: true,
      link: "https://masaischool.com/fees",
    },
  ];
  const tabsLabelsList: {
    key: number;
    title: string;
    type: "primary" | "secondary" | "tab" | "hamburger-label";
    path: string;
    badgeComponent?: React.ReactElement;
    iconForPrimary?: React.ReactElement;
    iconForTab?: React.ReactElement;
  }[] = [
    {
      key: 1,
      title: "Courses",
      type: "tab",
      iconForTab: <SchoolOutline />,
      path: "/",
    },
    {
      key: 2,
      title: "Contests",
      type: "tab",
      iconForTab: <ContestOutline />,
      path: "/contests",
    },
    {
      key: 3,
      title: "Events & Contests",
      type: "tab",
      iconForTab: <CalenderTick />,
      path: "/events",
    },
    {
      key: 4,
      title: "Self learning (Free)",
      type: "tab",
      iconForTab: <BookOpen />,
      path: "/self-learning",
    },
  ];

  const onReferralModalClose = (btnType?: "skip" | "submit", referral_code?: string) => {
    updateReferral(referral_code);
  };

  React.useEffect(() => {
    let showModal = false;
    const skipped_referral_entry = state.profileData?.skipped_referral_entry;
    const referred_by = state.profileData?.referred_by;
    if (skipped_referral_entry === null && referred_by === null) {
      showModal = true;
    }
    // setIsReferralModalOpen(showModal);
  }, [state.profileData]);
  const dispatch = React.useContext(AppContext)[1];
  const updateReferral = (referral_code?: string) => {
    if (state.profileData?.slug) {
      updateReferralCode({
        profile_slug: state.profileData.slug,
        referral_code: referral_code,
      })
        .then((res) => {
          setIsReferralModalOpen(false);
          dispatch({
            type: ApplicationActionType.FETCH_PROFILE,
            payload: {},
          });
        })
        .catch((err) => {
          dispatch({
            type: ApplicationActionType.FETCH_PROFILE,
            payload: {},
          });
          const e = axiosErrorHandler(err);
          if (typeof e === "object" && "message" in e) {
            // snackbar.error(e.message);
            setReferralErrorMessage(e.message);
          } else {
            // snackbar.error("something went wrong");
            setReferralErrorMessage("Something went wrong!");
          }
        });
    }
  };
  const isMobile = useBreakpointValue({ base: true, md: false });
  const steps = [
    {
      selector: isMobile ? "#header-program-dropdown-mobile" : "#header-program-dropdown-desktop",
      content: (
        <Text textStyle={{ base: "body1", md: "body1" }}>
          Explore different programs by clicking on the above dropdown 👆
        </Text>
      ),
    },
    {
      selector: isMobile ? "#contest-nav-mobile" : "#contest-nav-desktop",
      content: (
        <Box>
          <Text textStyle={{ base: "body1-md", md: "body1-md" }}>Thinking of what to do next?</Text>
          <Text mt={"ms-12"} textStyle={{ base: "body1", md: "body1" }}>
            Take part in Contests, improve your knowledge & stay ahead of the crowd by clicking on
            Contests 👈
          </Text>
        </Box>
      ),
    },
    {
      selector: isMobile ? "#user-profile" : "#user-profile",
      content: (
        <Text mt={"ms-12"} textStyle={{ base: "body1", md: "body1" }}>
          Access your profile by clicking on the above dropdown 👆
        </Text>
      ),
    },
  ];
  const location = useLocation();
  const [currentTourState, setCurrentTourState] = React.useState<number>(-1);
  return (
    <>
      <Box height="100vh" d={"flex"} flexDirection={"column"}>
        <Box zIndex={"10"}>
          <Header />
        </Box>
        <Box
          zIndex={"10"}
          mt={"20"}
          position={"fixed"}
          bottom={"0"}
          overflow={"hidden"}
          width={"100%"}
        >
          <BottomTabNavbar height={Constants.bottomNavbarHeight} tabsLabelsList={tabsLabelsList} />
        </Box>
        <LeftNavigation
          width={Constants.sidePanelWidth}
          height={`100vh`}
          topLabelsList={topLabelsList}
          bottomLabelsList={bottomLabelsList}
        />
        <Box as="main" w="100%" p="0" mx="0" pb={Constants.bottomNavbarHeight}>
          <Flex h="100%" w="100%">
            <Box
              pl={{
                base: "0rem",
                md: Constants.sidePanelWidth,
              }}
              pt="3.5rem"
              h="100%"
              w="100%"
            >
              {children}
            </Box>
          </Flex>
        </Box>
      </Box>
      <ModalTemplate
        title=""
        isOpen={isReferralModalOpen === undefined ? false : isReferralModalOpen}
        onClose={onReferralModalClose}
        marginX={2}
        maxWidth="552px"
        showCloseButtonIcon={false}
        closeOnOverlayClick={false}
      >
        <ReferralCodeModalContent
          onReferralModalClose={onReferralModalClose}
          referralErrorMessage={referralErrorMessage}
          setReferralErrorMessage={setReferralErrorMessage}
        />
      </ModalTemplate>
      <Tour
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        getCurrentStep={(curr: number) =>
          setCurrentTourState((prevState: number) => (prevState !== curr ? curr : prevState))
        }
        badgeContent={(curr: number, tot: number) => `Step ${curr}/${tot}`}
        steps={steps}
        isOpen={state.showGuidedTour}
        onRequestClose={() => {
          dispatch({
            type: ApplicationActionType.SET_GUIDED_TOUR,
            payload: { showGuidedTour: false },
          });
        }}
        prevButton={
          <Button
            onClick={() => {
              if (currentTourState < 0) return;
              sendTrackingEvent({
                event: `guided_tour_prev_${currentTourState + 1}`,
                eventLabel: location.pathname,
              });
            }}
            disabled={currentTourState === 0}
            variant={"secondary"}
            size="sm"
          >
            Prev
          </Button>
        }
        nextButton={
          <Button
            onClick={() => {
              if (currentTourState < 0) return;
              sendTrackingEvent({
                event: `guided_tour_next_${currentTourState + 1}`,
                eventLabel: location.pathname,
              });
            }}
            variant={"primary"}
            size="sm"
          >
            Next
          </Button>
        }
        lastStepNextButton={
          <Button
            onClick={() => {
              sendTrackingEvent({
                event: `guided_tour_got_it`,
                eventLabel: location.pathname,
              });
              localStorage.setItem(
                "guided-tour-done-" + state.profileData?.slug,
                JSON.stringify(true)
              );
            }}
            variant={"primary"}
            size="sm"
          >
            Got It!
          </Button>
        }
      />
    </>
  );
};

export default Layout;
